import { idnr } from '@navikt/fnrvalidator';
import * as yup from 'yup';

import { FormTypeApplicationCoApplicant, FormTypeApplicationMainApplicant } from '../actions/forms';
import errorText from './validationTexts';

/* Main Applicant */
export const mainApplicantSchema: yup.ObjectSchema<FormTypeApplicationMainApplicant> = yup.object({
    email: yup.string().trim().email(errorText.emailInvalid).required(errorText.emailRequired),

    phone: yup
        .string()
        .trim()
        .min(8, errorText.phoneLength)
        .max(8, errorText.phoneLength)
        .required(errorText.phoneLength),

    livingConditionCode: yup.string().required(errorText.livingConditionRequired),

    rentalFee: yup.number().min(0, errorText.rentalFeeRequired).max(9999999, errorText.rentalFeeLength),

    employmentConditionCode: yup.string().required(errorText.employmentRequired),

    grossIncome: yup.number().min(0, errorText.grossIncomeRequired).max(1000000000, errorText.grossIncomeMax),

    totalDebt: yup.number().min(0, errorText.totalDebtRequired).max(1000000000, errorText.totalDebtMax),

    tradeIn: yup.boolean().required(),

    tradeInDebt: yup.number(),
});

/* Co Applicant */
export const coApplicantSchema: yup.ObjectSchema<FormTypeApplicationCoApplicant> = yup.object({
    hasCoApplicant: yup.boolean(),

    confirmAddress: yup.boolean().when('hasCoApplicant', {
        is: true,
        then: (schema) =>
            schema.oneOf([true], errorText.coApplicantSameAddress).required(errorText.coApplicantSameAddress),
    }),

    ssn: yup.string().when('hasCoApplicant', {
        is: true,
        then: (schema) =>
            schema
                .trim()
                .test('ssnValidation', errorText.ssn, (value) => {
                    if (value !== undefined) {
                        return idnr(`${value}`).status !== 'invalid';
                    }
                    return false;
                })
                .min(11, errorText.ssn)
                .max(11, errorText.ssn)
                .required(errorText.ssn),
    }),

    email: yup.string().trim().email(errorText.emailInvalid).required(errorText.emailRequired),

    phone: yup
        .string()
        .trim()
        .min(8, errorText.phoneLength)
        .max(8, errorText.phoneLength)
        .required(errorText.phoneLength),

    livingConditionCode: yup.string().required(errorText.livingConditionRequired),

    rentalFee: yup.number().min(0, errorText.rentalFeeRequired).max(9999999, errorText.rentalFeeLength),

    employmentConditionCode: yup.string().required(errorText.employmentRequired),

    grossIncome: yup.number().min(0, errorText.grossIncomeRequired).max(1000000000, errorText.grossIncomeMax),

    totalDebt: yup
        .number()
        .integer(errorText.totalDebtRequired)
        .min(0, errorText.totalDebtRequired)
        .max(1000000000, errorText.totalDebtMax)
        .required(errorText.totalDebtRequired),

    tradeIn: yup.boolean().required(),

    tradeInDebt: yup.number(),
});

/* Feedback */
export const feedbackSchema = yup.object().shape({
    feedbackMessage: yup.string().required(errorText.feedbackMessageRequired).max(500, errorText.feedbackMessageMax),
});
